import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App, { AdminRoot } from "./App";
import { AppProvider } from "./State/Context";
import { RulesPage } from "./Rules/RulesPage";
import { TopsPage } from "./Tops/TopsPage";
import { SpeedtestPage } from "./Speedtest/SpeedtestPage";

const gitCommit = typeof process.env.REACT_APP_GIT_COMMIT !== "undefined" ? process.env.REACT_APP_GIT_COMMIT : "dev";
if (typeof console !== "undefined" && console.log) {
  console.log("[build] git commit:", gitCommit);
  console.log("[build] video fallback: timeout-only (no pause/suspend)");
}

const path =
  typeof window !== "undefined"
    ? (window.location.pathname || "").replace(/\/$/, "") || ""
    : "";
const isAdmin = path === "/admin";
const isRules = path === "/rules";
const isSpeedtest = path === "/speedtest";
const topsMatch = path.match(/^\/tops\/([^/]+)$/);
const topsSlug = topsMatch ? topsMatch[1] : null;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <AppProvider>
    {isAdmin ? (
      <AdminRoot />
    ) : isRules ? (
      <RulesPage />
    ) : isSpeedtest ? (
      <SpeedtestPage />
    ) : topsSlug ? (
      <TopsPage slug={topsSlug} />
    ) : (
      <App />
    )}
  </AppProvider>
);
